export default __webpack_public_path__ + "static/1848-bdd2cb0c81c5f85d1949a4a41499408f.gif";